import router from '../router/index'
import { inject, h, createApp } from 'vue'
import { addUnit } from '@Utils/index'
import { setCommonApp } from '../utils/setCommonApp'
import { Drawer, Button } from 'view-ui-plus'

const noop = () => {}
const sizes = {
  small: 320,
  middle: 480,
  large: 720
}
function drawer(options) {
  const {
    width,
    title = '',
    size = 'default',
    render,
    component,
    okText = '确定',
    cancelText = '取消',
    className = '',
    maskClosable = false,
    closable = true,
    scrollable = false,
    fullscreen = false,
    draggable = false,
    footerHide = false,
    styles = {}
  } = options
  const props = {
    title,
    width,
    closable,
    modelValue: true,
    maskClosable,
    scrollable,
    draggable,
    styles,
    className
  }
  const container = document.createElement('div')
  document.body.appendChild(container)
  const instance = createApp({
    name: 'BizDrawer',
    router,
    data: () => {
      return {
        loading: false,
        visible: true,
        disabled: false,
        width: width === undefined ? sizes[size] || sizes.default : width,
        title
      }
    },
    created() {
      this.visible = true
    },
    methods: {
      onOk(data) {
        options.onOk && options.onOk(data)
        this.destroy()
      },
      onCancel() {
        options.onCancel && options.onCancel()
        this.destroy()
      },
      destroy() {
        this.loading = false
        this.visible = false
        instance.unmount()
        document.body.contains(container) && document.body.removeChild(container)
      }
    },
    render() {
      const btns = options.buttons || [
        {
          id: 'cancel',
          name: cancelText,
          type: 'primary',
          style: {
            marginRight: '16px'
          }
        },
        {
          id: 'ok',
          name: okText,
          type: 'primary'
        }
      ]
      let footerBtn = null
      if (!footerHide) {
        footerBtn = h(
          'div',
          {
            style: {
              textAlign: 'right',
              width: addUnit(this.width),
              position: 'fixed',
              bottom: 0,
              borderTop: '1px solid #EAECF0',
              padding: '12px 24px',
              marginLeft: '-16px',
              marginRight: '-16px'
            }
          },
          btns.map(item => {
            return h(
              Button,
              {
                type: item.type,
                size: item.size || size,
                ghost: item.id === 'cancel' || item.ghost,
                disabled: item.id === 'ok' ? this.disabled : false,
                loading: item.id === 'ok' ? this.loading : false,
                class: item.class || {},
                style: item.style || {},
                onClick: () => {
                  const { id } = item || {}
                  const name = `on${id[0].toUpperCase()}${id.substr(1)}`
                  const callback = (options[name] || noop)()
                  if (!callback || !callback.then) {
                    return this.destroy()
                  }
                  this.loading = true
                  callback
                    .then(() => this.destroy())
                    .catch(() => {
                      this.loading = false
                    })
                }
              },
              {
                default: () => item.name
              }
            )
          })
        )
      }
      return h(
        Drawer,
        {
          ...props,
          onOnVisibleChange: show => {
            if (!show) {
              this.onCancel()
            }
          }
        },
        {
          default: props =>
            component === undefined
              ? render(h)
              : h(
                  'div',
                  {},
                  {
                    default: () => [
                      h(component, {
                        ...(options.props || {}),
                        onDisabled: val => {
                          this.disabled = !!val
                        }
                      }),
                      footerBtn
                    ]
                  }
                )
        }
      )
    }
  })
  setCommonApp(instance)

  instance.mount(container)
  return instance
}
export function open(options) {
  return drawer(options)
}
const $drawer = {
  open
}
export const drawerPlugin = {
  install: (app, options) => {
    app.provide('BizDrawer', $drawer)
    app.config.globalProperties.$drawer = $drawer
  }
}
// 选项式用this.$drawer.open，usePluginDrawer().open
export const usePluginDrawer = () => {
  return $drawer
}
